type T = (name: string) => void;

const f: T = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${window.location.hostname};secure;SameSite=None`;
};

export default f;
